<template>
  <div>
    门店照片
  </div>
</template>

<script>
export default {
  name: 'StoreImage',
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
